<template>
    <div>
        <template v-if="!loaded">
            <div
                style="width: 100%;height: 100%;position: absolute;display: flex;justify-content: center;align-items: center;">
                <loading />
            </div>
        </template>

        <div style="width: 100%;height: 100%;position: absolute;display: flex;justify-content: center;align-items: center;" v-if="loaded">
            <div style="text-align: center;">
                <h3>{{fail_message}}</h3>
                <p>{{translate(locale.redirect)}}</p>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        created() {

            let token = this.config.getCookie("misti_single_id_login_token");
            let auth_token = this.$route.query.authToken;
            let decoded_token = this.config.base64decode(token);

            let checkToken = this.config.isJWT(decoded_token);

            if (checkToken.valid) {
                this.token = decoded_token;
                this.auth_token = auth_token;
                this.home_url = checkToken.data.home_url;
                this.authenticate_camdigikey_auth_token();
            } else {

            }
        },
        data() {
            return {
                loaded: false,
                token: "",
                auth_token: "",
                home_url: "",
                fail_message: "",
                expired: false
            }
        },
        methods: {
            authenticate_camdigikey_auth_token() {
                this.$store.state.pending.is = true;
                this.$http.post(this.config.api + "/user/camdigikey_authenticate", { token: this.token, auth_token: this.auth_token }).then(res => {

                    this.$store.state.pending.is = false;
                    this.loaded = true;

                    if (res.body.status == 'expired') {
                        this.$router.push("/login/" + this.config.base64encode(this.token));
                    }

                    if (res.body.status == 'fail') {
                        
                        this.fail_message = res.body.message;
                        // this.$notification.notify({
                        //     message: res.body.message,
                        //     icon: 'error',
                        //     type: 'danger'
                        // });
                        setTimeout(() => {
                            this.$router.push("/login/" + this.config.base64encode(this.token));
                        }, 3000);
                    }

                    if (res.body.status == 'success') {
                        if (res.body.data.redirect_url != undefined) {
                            window.location.replace(res.body.data.redirect_url);
                            this.$cookie.delete("misti_single_id_login_token");
                            return;
                        }
                    }

                    this.$store.state.pending.is = false;
                })
            }
        }
    }
</script>

<style scoped>
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity .1s
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0
    }

    .instruction-title {
        font-size: 16px;
    }

    .instruction>ul {
        list-style-type: none;
    }

    .instruction>ul>li {
        line-height: 28px;
    }

    .change-password-button {
        cursor: pointer;
    }

    .qr_image {
        margin: 40px 0;
        height: 250px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
    }

    .back-container {
        position: absolute;
        top: 15px;
        left: 15px;
    }

    .language-container {
        position: absolute;
        top: 18px;
        right: 18px;
    }

    .method-list {
        width: 100%;
        margin-top: 20px;
    }

    .method-container {
        cursor: pointer;
        width: 100%;
        margin-bottom: 20px;
        display: flex;
        border-radius: 6px;
        -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
        border: 1px solid transparent;
        transition: 300ms;
    }

    .method-container:hover {
        border: 1px solid #00CCFF;
        background-color: #F5FEFF;
    }

    .method-icon {
        padding: 30px;
    }

    .method-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-right: 30px;
    }

    .method-title {
        font-weight: 800;
        margin-bottom: 2px;
        font-family: "Open Sans", "Kantumruy Pro", sans-serif;
    }

    .method-text {
        font-size: 14px;
        margin-bottom: 0;
    }

    .method-icon img {
        width: 50px;
        max-width: 50px;
        min-width: 50px;
    }

    .welcome {
        width: 100%;
        text-align: left;
    }

    .welcome-title {
        font-size: 28px;
        font-weight: 700;
        line-height: 38px;
        font-family: "Open Sans", "Kantumruy Pro", sans-serif;
    }

    .welcome-text {
        margin-top: 20px;
        font-size: 18px;
        line-height: 32px;
    }

    .system-feature {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        min-height: 100vh;
        padding: 120px;
        padding-bottom: 220px;
        transition: 300ms;
    }

    .system-info {
        overflow: hidden;
        position: relative;
        margin: 0 -15px;
    }

    .system-container {
        background-image: url("/single_id.jpg");
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        min-height: 100vh;
        background-attachment: scroll;
        padding: 40px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .system-title {
        font-family: "Open Sans", "Kantumruy Pro", sans-serif;
        text-align: center;
        color: #FFF;
        font-weight: 700;
        margin-top: 50px;
        margin-bottom: 100px;
        font-size: 26px;
    }

    .system-ministry {
        text-align: center;
    }

    .system-ministry p {
        color: #FFF;
        font-weight: 700;
        font-family: "Open Sans", "Kantumruy Pro", sans-serif;
    }

    .ministry-khmer {
        font-size: 18px;
    }

    .ministry-logo {
        margin-bottom: 20px;
        width: 100px;
    }

    .login-page {
        position: absolute;
        width: 100%;
        height: 100%;
    }

    @media (max-width: 1264px) {
        .method-text {
            font-size: 12px;
        }

        .system-container {
            min-height: 0;
            padding: 20px;
        }

        .system-feature {
            min-height: 0;
            padding-bottom: 20px;
            padding: 80px 15px 15px 15px;

        }

        .system-title {
            font-size: 20px;
            margin-top: 20px;
            margin-bottom: 20px;
        }

        .system-ministry p {
            color: #FFF;
            font-weight: 700;
            font-size: 12px;
            font-family: "Open Sans", "Kantumruy Pro", sans-serif;
        }

        .ministry-khmer {
            font-size: 14px !important;
        }

        .back-container {
            left: 0;
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/LoginSuccess.vue